import { FC } from 'react';

import withSchema from 'ia-react-core/~/hocs/schema/withSchema';
import { PaginationState } from 'ia-react-core/~/interfaces/PaginationState';
import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';
import { ActionMap } from 'ia-react-core/~/interfaces/ReducerActions';

import setPaginationPageById from '../../../actions/pagination-fn/setPaginationPageById';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectReducer from '../../../hocs/redux/injectReducer';
import injectTranslations from '../../../hocs/translation/injectTranslations';
import compose from '../../../utils/components/_compose';

import Pagination, { PaginationComposedProps, PaginationProps, PaginationStatics } from './Pagination';
import paginationReducer from './Pagination.reducer';

import en from './translations/en';
import fr from './translations/fr';

const ComposedPagination = compose<FC<PaginationProps> & PaginationStatics>(
  withUniqueId('paginationId'),
  withSchema('pagination', { skip: ({ currentPage }) => typeof currentPage !== 'undefined' }),
  injectReducer<PaginationComposedProps, PaginationState>({
    key: ({ name }) => name,
    idName: 'paginationId',
    namespace: 'Core/Pagination',
    skip: ({ currentPage }) => typeof currentPage !== 'undefined',
    identifiers: ({ paginationId, name }) => ({ paginationId, name }),
    reducer: paginationReducer,
    actions: ({ paginationId: currentPaginationId }) => ({
      setPage: (...args: ParametersExceptFirst<typeof setPaginationPageById>) => setPaginationPageById(currentPaginationId, ...args),
    } as ActionMap),
    initialState: ({ paginationId, name, currentPage, initialCurrentPage }) => ({
      paginationId,
      name,
      currentPage: currentPage || initialCurrentPage || 1,
    }),
    useScope: true,
    createScope: false,
    cleanState: true,
  }),
  injectTranslations('Core.Pagination', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(Pagination);

ComposedPagination.displayName = 'Pagination';

export * from './Pagination';
export default ComposedPagination;
